import React from "react";

import styles from "./Support.module.css";
import { TopBar } from "../../components/TopBar/TopBar";
import whatsappIcon from "../../asset/icons/whatsapp.png";

const WHATSAPP_NUMBER = "919148477518";
const SUPPORT_EMAIL = "help@getfleek.app";

const TOPICS = [
  "My licence key hasn't arrived",
  "The key isn't working",
  "I paid but the order isn't showing",
  "I want a refund",
  "Change my email or number",
];

const whatsappUrl = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

/**
 * Support, rebuilt from design/Purchase Flow.dc.html (isSupport block).
 * Each common issue opens WhatsApp with the topic already typed.
 */
export const Support = () => (
  <div className={styles.page}>
    <TopBar title="Support" backTo="/account" />
    <div className={styles.shell}>
      <section className={styles.hero}>
        <p className={styles.heroTitle}>We reply in a few hours, every day</p>
        <p className={styles.heroBody}>
          Fastest on WhatsApp — send your order number and we'll pick it up from there.
        </p>
        <a className={styles.whatsapp} href={whatsappUrl()} target="_blank" rel="noopener noreferrer">
          <img src={whatsappIcon} alt="" className={styles.whatsappIcon} />
          Chat on WhatsApp
        </a>
      </section>

      <section className={styles.section}>
        <span className={styles.eyebrow}>Common issues</span>
        <div className={styles.topics}>
          {TOPICS.map((topic) => (
            <a
              key={topic}
              className={styles.topic}
              href={whatsappUrl(`Hi Fleek — ${topic}.`)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className={styles.topicText}>{topic}</span>
              <span className={styles.topicChevron} aria-hidden="true">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 6l6 6-6 6" />
                </svg>
              </span>
            </a>
          ))}
        </div>
      </section>

      <section className={styles.email}>
        <span className={styles.emailLabel}>Still stuck? Email us at</span>
        <a className={styles.emailAddress} href={`mailto:${SUPPORT_EMAIL}`}>
          {SUPPORT_EMAIL}
        </a>
      </section>
    </div>
  </div>
);

export default Support;
